// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const _ = import.meta.globEager("./**/*_channel.js");

import "../css/index.css";
import "@fontsource-variable/inter";
import "@fontsource-variable/public-sans";

import Rails from "@rails/ujs";
// Alpine import
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";

window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.start();
// // DOM Polyfills (Babel only covers ES6 features, not browser stuff)
// require("../javascript/polyfills.js")
import "../../webpacker/javascript/installOnDom.js";
import "../../webpacker/javascript/infinite_scroll.js";

// Webpack processes the SCSS, thus its presence here.
// import "../../webpacker/stylesheets/application.scss";

// Error monitoring
// import * as Sentry from "@sentry/browser"

// Sentry.init({
//   dsn:
//     "https://d03b49b54f70482384e57388708ed20a@o4504624549199872.ingest.sentry.io/4504624568795136"
// })

// Real User Monitoring.
//
// Loaded lazily, and only when the config tag is present. The OpenTelemetry
// web SDK plus the protobuf exporter weigh ~78 kB gzipped, several times the
// rest of this entrypoint, so keeping it in the critical path would slow the
// very page loads it exists to measure. As a deferred chunk it costs nothing
// until the browser is idle.
//
// Core Web Vitals still report correctly from a late start: web-vitals reads
// buffered PerformanceObserver entries. The document-load span is the one
// signal that may be missed, which the vitals cover better anyway.
function loadRum() {
  import("../otel/rum.js")
    .then(({ startRum }) => startRum())
    .catch(() => {});
}

if (document.querySelector('meta[name="rum-config"]')) {
  if ("requestIdleCallback" in window) {
    requestIdleCallback(loadRum, { timeout: 5000 });
  } else {
    window.addEventListener("load", () => setTimeout(loadRum, 0));
  }
}
